import {
  COOKIE_EXPIRED,
  COOKIE_TOKEN,
  COOKIE_USER_ID,
  COOKIE_USER_NAME,
  COOKIE_LOCAL_IP,
  COOKIE_TEMA,
} from "App/constants";
import { AES, enc } from "crypto-js";
import Cookies from "js-cookie";
import { isNull } from "./helpers";

const tokenListName = ["token", "token-emr-v2"];

const decryptToken = () => {
  // let result = null;

  // tokenListName.map((x) => {
  //   const token = Cookies.get(x);
  //   if (!isNull(token) && !isNull(result)) {
  //     const bytes = AES.decrypt(token, process.env.REACT_APP_SECRET_KEY);
  //     const decryptedData = JSON.parse(bytes.toString(enc.Utf8));
  //     result = decryptedData;
  //   } else {
  //     result = {
  //       token: "",
  //       tema: "",
  //       user_id: "",
  //       user_name: "",
  //       local_ip: "",
  //     };
  //   }
  // });

  let result = undefined;

  for (let i = 0; i < tokenListName.length; i++) {
    const token = Cookies.get(tokenListName[i]);
    if (!isNull(token)) {
      const bytes = AES.decrypt(
        token,
        process.env.REACT_APP_SECRET_KEY ?? "Ann154Annisa2021*#"
      );
      const decryptedData = JSON.parse(bytes.toString(enc.Utf8));
      result = decryptedData;
      break;
    }
  }

  if (isNull(result)) {
    return {
      token: "",
      tema: "",
      user_id: "",
      user_name: "",
      local_ip: "",
    };
  } else {
    return result;
  }
};

export const removeCookie = () => {
  tokenListName.map((x) => {
    return Cookies.remove(x);
  });
  Cookies.remove(COOKIE_USER_ID);
  Cookies.remove(COOKIE_USER_NAME);
  Cookies.remove(COOKIE_LOCAL_IP);
  Cookies.remove(COOKIE_TEMA);
};

export const setCookieLogin = (data) => {
  const dataEncrypt = {
    token: data.token,
    user_id: data.body.id,
    user_name: data.body.username,
    nama_rumah_sakit: data.body.rumah_sakit.name,

    role_code: data.body.role_code,
    role_name: data.body.role_name,
    apps: data.body.apps,

    kota_rumah_sakit: data.body.rumah_sakit.city,
    kode_pos_rumah_sakit: data.body.rumah_sakit.postal_code,
    no_tlp_rumah_sakit: data.body.rumah_sakit.no_tlpn,
    fax_rumah_sakit: data.body.rumah_sakit.fax,

    id_rumah_sakit: data.body.rumah_sakit.id,
    theme: data.body.tema,
    local_ip: data.body.ip_lokal.split("::ffff:")[1],
    bpjs_id: data.bpjs_id,

    id_unit: data?.body?.unit?.id_unit??null,
    nama_unit: data?.body?.unit?.nama_unit??null
  };

  const tokenEncrypt = AES.encrypt(
    JSON.stringify(dataEncrypt),
    process.env.REACT_APP_SECRET_KEY
  );
  setThema(dataEncrypt.theme);

  return setToken(tokenEncrypt);
};

export const setToken = (token) => {
  return Cookies.set(COOKIE_TOKEN, token, {
    expires: COOKIE_EXPIRED,
  });
};

export const setThema = (name) => {
  return Cookies.set(COOKIE_TEMA, name, {
    expires: COOKIE_EXPIRED,
  });
};

export const setUserName = (name) => {
  return Cookies.set(COOKIE_USER_NAME, name, {
    expires: COOKIE_EXPIRED,
  });
};

export const setLocalIP = (name) => {
  return Cookies.set(COOKIE_LOCAL_IP, name, {
    expires: COOKIE_EXPIRED,
  });
};

export const setUserID = (id) => {
  return Cookies.set(COOKIE_USER_ID, id, {
    expires: COOKIE_EXPIRED,
  });
};

export const getToken = () => {
  return decryptToken().token;
};

export const getBpjsID = () => {
  return decryptToken().bpjs_id;
};

export const getLocalIP = () => {
  return decryptToken().local_ip;
};

export const getUserName = () => {
  return decryptToken().user_name;
};

export const getUserID = () => {
  return decryptToken().user_id;
};

export const getThema = () => {
  return decryptToken().theme;
};

export const getRoleCode = () => {
  return decryptToken().role_code;
};

export const getRoleName = () => {
  return decryptToken().role_name;
};

export const getApps = () => {
  return decryptToken().apps;
};

export const getNamaRumahSakit = () => {
  return decryptToken().nama_rumah_sakit;
};

export const getKotaRumahSakit = () => {
  return decryptToken().kota_rumah_sakit;
};

export const getFaxRumahSakit = () => {
  return decryptToken().fax_rumah_sakit;
};

export const getNoTlpRumahSakit = () => {
  return decryptToken().no_tlp_rumah_sakit;
};

export const getKodePosRumahSakit = () => {
  return decryptToken().kode_pos_rumah_sakit;
};

export const getIDRumahSakit = () => {
  return decryptToken().id_rumah_sakit;
};

export const getIDunit = () => {
    return decryptToken().id_unit;
  };

export const getNamaUnit = () => {
    return decryptToken().nama_unit;
  };